
          import Aside from "components/mdx/Aside"

          export default { Aside }
        